import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RecuperarCuenta = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    // Cargar Font Awesome para los iconos (igual que en LoginPage)
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
        document.head.appendChild(link);
    }, []);

    const handleVerify = () => {
        if (!email) return alert("Por favor, ingrese su correo.");
        console.log("Enviando código a:", email);
        alert("Si el correo existe, recibirás un código de verificación.");
    };

    const handleUpdatePassword = (e) => {
        e.preventDefault();
        alert("Contraseña actualizada con éxito");
        navigate('/login');
    };

    return (
        <div style={containerStyle}>
            {/* Logo y Encabezado */}
            <div style={{ marginBottom: '30px', textAlign: 'center' }}>
                <img 
                    src="/img/LogoBambo.png" 
                    alt="Bambo Logo" 
                    style={{ width: '100px', marginBottom: '10px' }} 
                    onError={(e) => e.target.style.display = 'none'}
                />
                <h2 style={headerStyle}>RECUPERAR CUENTA</h2>
            </div>

            <div style={cardStyle}>
                <form onSubmit={handleUpdatePassword} style={formStyle}>
                    
                    {/* Campo Correo */}
                    <div style={inputGroupStyle}>
                        <label style={labelStyle}>CORREO ELECTRÓNICO</label>
                        <div style={{ position: 'relative' }}>
                            <i className="fa-solid fa-envelope" style={iconInsideInput}></i>
                            <input 
                                type="email" 
                                placeholder="Ej: usuario@mail.com" 
                                style={inputStyle}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    {/* Fila de Código de Verificación */}
                    <div style={inputGroupStyle}>
                        <label style={labelStyle}>CÓDIGO DE SEGURIDAD</label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <div style={{ position: 'relative', flex: 1 }}>
                                <i className="fa-solid fa-key" style={iconInsideInput}></i>
                                <input 
                                    type="text" 
                                    placeholder="000000" 
                                    style={inputStyle} 
                                    required 
                                />
                            </div>
                            <button type="button" onClick={handleVerify} style={verifyBtnStyle}>
                                VERIFICAR
                            </button>
                        </div>
                    </div>

                    {/* Campos de Nueva Contraseña */}
                    <div style={inputGroupStyle}>
                        <label style={labelStyle}>NUEVA CONTRASEÑA</label>
                        <div style={{ position: 'relative' }}>
                            <i className="fa-solid fa-lock" style={iconInsideInput}></i>
                            <input type="password" placeholder="••••••••" style={inputStyle} required />
                        </div>
                    </div>

                    <div style={inputGroupStyle}>
                        <label style={labelStyle}>REPETIR CONTRASEÑA</label>
                        <div style={{ position: 'relative' }}>
                            <i className="fa-solid fa-shield-halved" style={iconInsideInput}></i>
                            <input type="password" placeholder="••••••••" style={inputStyle} required />
                        </div>
                    </div>

                    {/* Botones de Acción */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px' }}>
                        <button type="submit" style={btnSubmit}>ACTUALIZAR CONTRASEÑA</button>
                        <button type="button" onClick={() => navigate('/login')} style={backBtnStyle}>
                            ← VOLVER AL LOGIN
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

// --- ESTILOS MEJORADOS (MATCH CON LOGINPAGE) ---
const containerStyle = { 
    display: 'flex', 
    flexDirection: 'column',
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '100vh', 
    backgroundColor: '#000', 
    fontFamily: 'Arial, sans-serif',
    color: '#fff' 
};

const headerStyle = { 
    letterSpacing: '3px', 
    fontWeight: '900', 
    color: '#FFD700', 
    fontSize: '22px',
    margin: 0 
};

const cardStyle = { 
    backgroundColor: '#111', 
    padding: '40px', 
    borderRadius: '15px', 
    border: '1px solid #333', 
    boxShadow: '0 10px 30px rgba(0,0,0,0.5)', 
    width: '100%', 
    maxWidth: '420px' 
};

const formStyle = { display: 'flex', flexDirection: 'column', gap: '20px' };

const inputGroupStyle = { display: 'flex', flexDirection: 'column', gap: '8px' };

const labelStyle = { 
    fontSize: '12px', 
    color: '#FFD700', 
    fontWeight: 'bold', 
    marginLeft: '5px',
    textTransform: 'uppercase' 
};

const inputStyle = { 
    width: '100%', 
    padding: '12px 12px 12px 40px', 
    backgroundColor: '#1a1a1a', 
    border: '1px solid #333', 
    borderRadius: '8px', 
    fontSize: '15px', 
    color: '#fff', 
    outline: 'none', 
    boxSizing: 'border-box' 
};

const iconInsideInput = { 
    position: 'absolute', 
    left: '12px', 
    top: '50%', 
    transform: 'translateY(-50%)', 
    color: '#444' 
};

const verifyBtnStyle = {
    padding: '0 15px',
    backgroundColor: 'transparent',
    color: '#FFD700',
    border: '1px solid #FFD700',
    borderRadius: '8px',
    fontWeight: 'bold',
    fontSize: '12px',
    cursor: 'pointer',
    transition: '0.3s'
};

const btnSubmit = { 
    backgroundColor: '#FFD700', 
    color: '#000', 
    padding: '15px', 
    border: 'none', 
    borderRadius: '8px', 
    fontWeight: '900', 
    fontSize: '15px', 
    cursor: 'pointer', 
    textTransform: 'uppercase',
    transition: '0.3s' 
};

const backBtnStyle = { 
    marginTop: '10px', 
    color: '#666', 
    background: 'none', 
    border: 'none', 
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 'bold'
};

export default RecuperarCuenta;